// --- IMPORTS قبلی دست نخورده ---
import * as React from 'react'

import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Icon from 'Components/Icon'
import { useNetStatus } from 'Contexts/NetStatusContext'
import NotificationFilter from './NotificationFilter'
import LoadingPage from 'Layouts/LoadingPage/LoadingPage'
import NotificationListItem from './NotificationListItem'
import DataNotFoundPage from 'Layouts/DataNotFoundPage/DataNotFoundPage'
import BottomSheetReadAll from './BottomSheetReadAll'
import { INotification } from 'Application/Notification/store/types'

import { useGetUserNotificationPagedFilterDIPQuery } from 'Application/Notification/services/api'

function Notification() {
  // const [getNotifications, { data, isLoading: notificationloading }] =
  //   useLazyGetUserNotificationPagedFilterDIPQuery();

  // console.log(data);
  const { data, isLoading: notificationloading } = useGetUserNotificationPagedFilterDIPQuery()

  const { t } = useTranslation()
  const navigate = useNavigate()
  const { netStatus } = useNetStatus()
  const listRef = React.useRef<HTMLDivElement | null>(null)

  const [open, setOpen] = React.useState(false)

  return (
    <div className="flex flex-col grow overflow-auto">
      <div className="flex justify-between items-center h-16 px-6 shrink-0">
        <div className="flex justify-between items-end gap-2">
          <div onClick={() => navigate('/')}>
            <Icon name="arrow-right" className="w-6 h-6 text-gray-700" />
          </div>
          <div className="text-lg font-bold pl-2 ">{t('MESSAGES')}</div>
        </div>
        <div className="flex justify-between items-center">
          <Icon
            className="cursor-pointer"
            name="circle-burger-menu"
            onClick={() => setOpen(true)}
          />
        </div>
      </div>

      <NotificationFilter />

      <div className="flex flex-col grow overflow-auto">
        {notificationloading && !data ? (
          <LoadingPage />
        ) : (
          <div className="flex flex-col grow overflow-auto">
            <div className="divide-y" ref={listRef} style={{ overflowY: 'scroll' }}>
              {data && data?.length > 0 ? (
                data.map((item: INotification) => <NotificationListItem key={item.id} {...item} />)
              ) : (
                <DataNotFoundPage
                  message={
                    netStatus == 'MANUAL_OFF' ? 'CONNECTION_ERROR' : 'NOTIFICATION_NOT_FOUND'
                  }
                />
              )}
            </div>
          </div>
        )}
      </div>

      <BottomSheetReadAll open={open} onClose={() => setOpen(false)} />
    </div>
  )
}

export default Notification
